import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../API/EndPoints";
import AxiosInstance from "../API/AxiosInstance";

export const getSpeciality = createAsyncThunk(
  "master/getAllSpeciality",
  async () => {
    const response = await AxiosInstance.get(API_ENDPOINTS.GET_ALL_SPECIALITY);
    return response.data;
  }
);

const specialitySlice = createSlice({
  name: "getSpeciality",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSpeciality.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSpeciality.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getSpeciality.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default specialitySlice.reducer;
